import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { formatCouponType, formatDate, getCachedMediaUrl } from '../../../lib/utils/utils';
import Modal from './Modals/Modal';

function CouponInfo() {
    const imageContainerRef = useRef(null);

    const coupon = useSelector((state) => state.coupons.coupon.coupon);

    const [mediaContainerHeight, setMediaContainerHeight] = useState(0);

    useEffect(() => {
        if(imageContainerRef.current) {
            setMediaContainerHeight(imageContainerRef.current.clientWidth);
        }
    }, [imageContainerRef]);

    const getCouponLimit = (limitUserBoolean, limitNumber) => {
        if (limitNumber == null && !limitUserBoolean) {
            return 'No Limitation';
        }

        return limitUserBoolean
            ? `${limitNumber} purchase per shopper`
            : `${limitNumber} purchases in total`;
    };


    return (
        <div className='mt-6 mx-5 flex gap-[18px]'>
            <div ref={imageContainerRef} className="w-[37%] flex items-center justify-center rounded-2xl overflow-hidden" style={{ height: `${mediaContainerHeight}px` }}>
                {
                    coupon?.pic ? 
                    <img className='max-w-full max-h-full' src={getCachedMediaUrl(coupon?.pic)} alt="" /> :
                    <div className="max-w-full max-h-full bg-[#D9D9D9]"></div>
                }
            </div>

            <div className="w-[63%] border border-[#EAEAEA] rounded-xl flex flex-col gap-3 p-5 h-fit">
                <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>{coupon?.couponName}</h1>

                <div className="flex flex-col gap-2">
                    <div className="w-full flex font-medium text-base">
                        <h1 className='w-1/2 text-[#666666]'>Coupon Type</h1>

                        <p className='w-1/2 text-[#121212]'>{formatCouponType(coupon?.typeCoupon)}</p>
                    </div>

                    <div className="h-[1px] w-full bg-[#EAEAEA]"></div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="w-full flex font-medium text-base">
                        <h1 className='w-1/2 text-[#666666]'>Set Type</h1>

                        <p className='w-1/2 text-[#121212]'>
                            {coupon?.selectTypeCoupon === 'CATEGORY' && 'Collection'}

                            {coupon?.selectTypeCoupon === 'CUSTOM_CATEGORY' && 'Custom Collection'}

                            {coupon?.selectTypeCoupon === 'PRODUCT' && 'Products'}
                        </p>
                    </div>

                    <div className="h-[1px] w-full bg-[#EAEAEA]"></div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="w-full flex font-medium text-base">
                        <h1 className='w-1/2 text-[#666666]'>Value</h1>

                        <p className='w-1/2 text-[#121212]'>
                            {formatCouponType(coupon?.typeCoupon) === 'Percentage Discount' && (coupon?.discountPercent + '%' + (coupon?.maxDiscount ? ' upto ' + '₹' + coupon.maxDiscount : ''))}

                            {formatCouponType(coupon?.typeCoupon) === 'Fixed Discount' && `₹${coupon?.discountMoney}`}

                            {formatCouponType(coupon?.typeCoupon) === 'Buy X, Get X' && `Buy ${coupon?.buyItem} Get ${coupon?.getItem}`}
                        </p>
                    </div>

                    <div className="h-[1px] w-full bg-[#EAEAEA]"></div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="w-full flex font-medium text-base">
                        <h1 className='w-1/2 text-[#666666]'>Purchase Requirement</h1>

                        <p className='w-1/2 text-[#121212]'>{coupon?.purchaseRequired ? `₹${coupon?.purchaseValue}` : 'No'}</p>
                    </div>

                    <div className="h-[1px] w-full bg-[#EAEAEA]"></div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="w-full flex font-medium text-base">
                        <h1 className='w-1/2 text-[#666666]'>Coupon Limitation</h1>

                        <p className='w-1/2 text-[#121212]'>{getCouponLimit(coupon?.limitUserBoolean, coupon?.limitNumber)}</p>
                    </div>

                    <div className="h-[1px] w-full bg-[#EAEAEA]"></div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="w-full flex font-medium text-base">
                        <h1 className='w-1/2 text-[#666666]'>Start Date</h1>

                        <p className='w-1/2 text-[#121212]'>{formatDate(coupon?.startDate)}</p>
                    </div>

                    <div className="h-[1px] w-full bg-[#EAEAEA]"></div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="w-full flex font-medium text-base">
                        <h1 className='w-1/2 text-[#666666]'>End Date</h1>

                        <p className='w-1/2 text-[#121212]'>{formatDate(coupon?.endDate)}</p>
                    </div>

                    <div className="h-[1px] w-full"></div>
                </div>
            </div>

            <Modal />
        </div>
    );
}

export default CouponInfo;
